module.exports = __webpack_public_path__ + "static/img/info4.18de09a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/pic/info4.jpg
// module id = jN21
// module chunks = 11